import { render, staticRenderFns } from "./AllReports.vue?vue&type=template&id=84b5c6fa&"
import script from "./AllReports.vue?vue&type=script&lang=js&"
export * from "./AllReports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports